import { CustomState } from "@bevco/Store/Reducers";
import { searchFilteringStateValues } from "@bevco/Utilities/Utilities";
import { colorStrings } from "@bevco/Utilities/variables";
import SearchFilteringFilters from "@bevco/Widgets/ProductList/SearchFilteringFilters";
import SearchFilteringFiltersTags from "@bevco/Widgets/ProductList/SearchFilteringFiltersTags";
import SearchFilteringSearchWithinFilter from "@bevco/Widgets/ProductList/SearchFilteringSearchWithinFilter";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Hidden from "@insite/mobius/Hidden";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import { safeColor } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: CustomState) => {
    const { loaded, loading } = searchFilteringStateValues(state);

    return {
        loaded,
        loading,
    };
};

type Props = ReturnType<typeof mapStateToProps>;

export interface ProductListTableViewSearchFilteringStyles {
    wrapper?: InjectableCss;
    loadingWrapper?: InjectableCss;
}

export const productListTableViewSearchFilteringStyles: ProductListTableViewSearchFilteringStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 24px;
            position: relative;
        `,
    },
    loadingWrapper: {
        css: css`
            align-items: center;
            background-color: ${safeColor(colorStrings.commonGlobalWhite).alpha(0.05).toString()};
            bottom: -10px;
            display: inline-flex;
            justify-content: center;
            left: -10px;
            position: absolute;
            right: -10px;
            top: -10px;
        `,
    },
};

const styles = productListTableViewSearchFilteringStyles;

const ProductListTableViewSearchFiltering: FC<Props> = ({ loaded, loading }) => {
    if (!loaded) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <SearchFilteringSearchWithinFilter />

            <Hidden below="md">
                <SearchFilteringFilters />
            </Hidden>

            <Hidden below="md">
                <SearchFilteringFiltersTags />
            </Hidden>

            <Hidden below="md">
                {loading && (
                    <StyledWrapper {...styles.loadingWrapper}>
                        <LoadingSpinner></LoadingSpinner>
                    </StyledWrapper>
                )}
            </Hidden>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ProductListTableViewSearchFiltering as any) as any,
    definition: {
        group: "Product List",
        displayName: "Search Filtering",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
